import * as Sentry from "@sentry/browser";
import { BrowserTracing } from "@sentry/tracing";

if(__buildEnv__ != 'local'){  
  Sentry.init({
    dsn: process.env.SENTRY_DSN,
    integrations: [new BrowserTracing()],
    environment: process.env.SENTRY_ENV,

    tracesSampleRate: 1.0,
  });

  window.Sentry = Sentry;
}


export default Sentry;
